export default __webpack_public_path__ + "static/media/sc-bottom.254aac3b.svg";